//
// const BASE_URL = 'https://adams-development.com:3042'
// eslint-disable-next-line no-restricted-globals
const BASE_URL = new URL('/ce-api', location)
//const BASE_URL = 'http://localhost:57814'

const httpReq = async (path, httpMethod, data, withToken) => {
    const verifyPath = path[0] !== '/' ? `/${path}` : path
    let headers = {
        'content-type': 'application/json'
        , accept: 'application/json'
    }
    if (withToken) {
        const token = localStorage.getItem('token')
        headers = { ...headers, Authorization: JSON.parse(token) }
    }
    let fetchObj = {
        method: httpMethod.toUpperCase(),
        headers
    }
    if(data){
        fetchObj = {...fetchObj, body: JSON.stringify(data)}
    }
    const url = `${BASE_URL}${verifyPath}`
    const response = await fetch(`${url}`, fetchObj)
    return response.json()
}
export default httpReq